/** Largest count a badge shows exactly; anything above renders as `${max}+`. */
export const DEFAULT_BADGE_MAX = 99;

/**
 * Text for a count badge: '' when there is nothing to show (the caller renders
 * nothing), the exact count up to `max`, then `${max}+`.
 */
export function formatBadgeCount(
  count: number,
  max: number = DEFAULT_BADGE_MAX,
): string {
  if (!Number.isFinite(count) || count <= 0) return '';
  const whole = Math.floor(count);
  return whole > max ? `${max}+` : String(whole);
}
